import { SectionDTO } from '@wix/package-picker-common';
import { FeatureSection, Types } from '@wix/package-picker-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Heading, Text } from '@wix/design-system';

interface GridFeatureSectionHeaderProps {
  section: SectionDTO;
}

export const GridFeatureSectionHeader: React.FC<
  GridFeatureSectionHeaderProps
> = ({ section }) => {
  const { t } = useTranslation();

  const handleClick = (_action: Types.CollapsibleAction) => {
    // TODO: Add BI event
  };

  return (
    <FeatureSection.Header
      labels={{
        open: t('Advanced.Plans_General_Show_features'),
        close: t('Advanced.Plans_General_Hide_features'),
      }}
      onToggle={handleClick}
    >
      <FeatureSection.Hoverable
        render={(isHovering) => (
          <Box direction='vertical'>
            <Heading appearance='H4'>{t(section.name)}</Heading>
            <Text size='small' skin={isHovering ? 'primary' : 'standard'}>
              {t(section.description)}
            </Text>
          </Box>
        )}
      />
    </FeatureSection.Header>
  );
};
